import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Mail, MapPin, Phone } from "lucide-react";
export default function Zapati() {
  const currentYear = new Date().getFullYear();
  const quickLinks = [{
    label: "Domů",
    href: "/HomePage"
  }, {
    label: "Služby",
    href: "/HomePage#services"
  }, {
    label: "Logistika",
    href: "/LogisticsPage"
  }, {
    label: "Kontakt",
    href: "/ContactPage"
  }];
  const legalLinks = [{
    label: "Ochrana osobních údajů",
    href: "#"
  }, {
    label: "GDPR",
    href: "#"
  }, {
    label: "Obchodní podmínky",
    href: "#"
  }];
  return <section id="zápatí" className="bg-slate-950 text-slate-400 py-12 lg:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/s_clean_logo_light.png" alt="S-clean prádelna Vršovice" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs">S‑clean prádelna Vršovice Praha je B2B průmyslová prádelna se sídlem ve Vršovicích. Poskytujeme vysokokapacitní praní pro hotely, apartmány, restaurace, Airbnb a spa s důrazem na hygienu a spolehlivost.</p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-slate-100 font-semibold tracking-tight">
              Rychlé odkazy
            </h3>
            <nav className="flex flex-col gap-2">
              {quickLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-sm hover:text-slate-100 transition-colors w-fit">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-slate-100 font-semibold tracking-tight">
              Kontakt
            </h3>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-slate-500" />
                <span>
                  Vršovice, Prague,
                  <br />
                  Czech Republic
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-slate-500" />
                <Link to="tel:+420607774723" className="hover:text-slate-100 transition-colors">+420 607 774 723</Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-slate-500" />
                <Link to="mailto:pradelna@struz.cz" className="hover:text-slate-100 transition-colors break-all">pradelna@struz.cz</Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-slate-100 font-semibold tracking-tight">
              Právní informace
            </h3>
            <nav className="flex flex-col gap-2">
              {legalLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-sm hover:text-slate-100 transition-colors w-fit">
                  {link.label}
                </Link>)}
            </nav>
          </div>
        </div>

        <Separator className="my-8 bg-slate-800" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <p>©&nbsp; S-clean prádelna Vršovice Praha. Všechna práva vyhrazena.</p>
          <p>Industrial Precision Laundry Service</p>
        </div>
      </div>
    </section>;
}